// extracted by mini-css-extract-plugin
module.exports = {"imgView":"ImgModal_imgView__1cixy","imgItem":"ImgModal_imgItem__yBAUf","closeIcon":"ImgModal_closeIcon__AAtTF"};